import React, { Component, useState } from 'react';
import CustomImage from '../../components/custom-image';

const SustainabilityAndCsr = () => {
  return (
    <div className="awards-content buttom-section">
      <div className="one-col">
        <h4>Sustainability & CSR</h4>
        <div className="table-wrapper">
          <div className="desktop-img">
            <CustomImage
              className="icon-arrow-up"
              imageName="sustainability-csr.png"
              alt="Sustainability & CSR"
              maxWidth="895"
            />
          </div>
          <div className="mobile-img">
            <div className="table-img">
              <CustomImage
                className="icon-arrow-up"
                imageName="sustainability-csr-mobile.png"
                alt="Sustainability & CSR"
                maxWidth="895"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SustainabilityAndCsr;
